module.exports = __webpack_public_path__ + "img/twitter-ico.8f35a404.png";